<template>
  <div style="height:400px;">
    <div class="title">
    </div>
    <div class="content" style="width: 100%;height: 100%;">
      <EchartColumnar
        v-if="isShow"
        :key="'ytjhedajysl'"
        :chart-id="'ytjhedajysl'"
        :color="['#4ecb73', '#1E90FF']"
        :color-by="'series'"
        :multiple-y-unit="true"
        :is-legend="true"
        :x-chart-num="xTypeName.length"
        :x-data="xdata"
        :y-data="ydata"
        :x-type-name="xTypeName"
        :chart-type="[{ type: 'line' ,yAxisIndex: 0, symbol: '' }]"
        :left="'50'"
        :right="'80'"
        :top="'8%'"
        :title="title"
        :bottom="'10%'"
        :legend-align="{ location:'bottom', align:'0' }"
      />
    </div>
  </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {
            isShow: false,
            isLoad: true,
            yunit: {},
            xdata: [],
            ydata: [
            ],
            title: '',
            xTypeName: [
            ]

        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        // this.getData()
        this.$bus.on('searchFn', this.getData)
    },
    beforeDestroy() {
        this.$bus.off('searchFn', this.getData)
    },
    mounted() {

    },
    methods: {
        // 获取数据
        getData(year, type) {
            let urlchange = 'barChartAndList'
            if (type == 1) {
                urlchange = 'barChartAndList'
            } else if (type == 2) {
                urlchange = 'barChartAndListWithType'
            } else if (type == 3) {
                urlchange = 'barChartAndListByZbfzr'
            }
            this.$http({
                method: 'get',
                url: '/zbgl/zbxmlx/' + urlchange,
                params: {
                    year: year
                }
            }).then(res => {
                if (res.code === 'success') {
                    this.xdata = res.body.vo.props.xData[0]

                    this.ydata = res.body.vo.props.yData
                    this.xTypeName = res.body.vo.props.xTypeName
                    console.log('this.xTypeName', this.xTypeName)
                    this.isShow = true
                }
            })
        }

    }
}
</script>

<style scoped lang="scss">

</style>
